module.exports = __webpack_public_path__ + "img/020-design-tool.e035a6d1.svg";